import CNBSelect from "./Select";

export default CNBSelect;
